document.addEventListener("DOMContentLoaded", function () {
  const container = document.getElementById("aparecer");
  const nome = document.getElementById("campo-personalizacao");
  const numero = document.getElementById("personalizar-numero");

  function verificarPersonalizacao() {
    const selected = document.querySelector('input[value="Personalizar"]:checked');
    
    if (selected) {
      container.classList.remove("removeContainerPersonalizar");
    } else {
      container.classList.add("removeContainerPersonalizar");

      // limpa os campos para não mandar dados quando não for personalizar
      if (nome) nome.value = "";
      if (numero) numero.value = "";
    }
  }

  // Rodar no carregamento inicial
  verificarPersonalizacao();

  // Escutar mudanças
  document.querySelectorAll('input[value="Personalizar"], input[value="Não Personalizar"]').forEach(radio => {
    radio.addEventListener("change", verificarPersonalizacao);
  });

  // 🔹 Garante que os campos vão junto pro carrinho
  document.addEventListener("submit", function (event) {
    const form = event.target.closest("form[action*='/cart/add']");
    if (!form) return;

    if (nome && nome.value.trim()) {
      let hiddenNome = document.createElement("input");
      hiddenNome.type = "hidden";
      hiddenNome.name = "properties[Nome]";
      hiddenNome.value = nome.value.trim();
      form.appendChild(hiddenNome);
    }

    if (numero && numero.value.trim()) {
      let hiddenNumero = document.createElement("input");
      hiddenNumero.type = "hidden";
      hiddenNumero.name = "properties[Número]";
      hiddenNumero.value = numero.value.trim();
      form.appendChild(hiddenNumero);
    }
  }, true);
});
